export const APP_NAME = import.meta.env.VITE_APP_NAME || '3asass.ma'
export const LANDING_URL = import.meta.env.VITE_LANDING_URL || 'http://3asass.local:8000'
/** The shared sign-in service customers come from. It keeps a session of its own. */
export const AUTH_URL = import.meta.env.VITE_AUTH_URL || 'http://auth.local:8000'

function versionedApiBaseUrl(value: string) {
  const baseUrl = value.replace(/\/$/, '')

  return baseUrl.endsWith('/v1') ? baseUrl : `${baseUrl}/v1`
}

export const API_BASE_URL = versionedApiBaseUrl(import.meta.env.VITE_API_BASE_URL || '/api/v1')

/**
 * The public key of the realtime server (Laravel Reverb). It identifies the app to the socket and
 * is meant to be public; the secret stays on the server. Empty means realtime is not configured
 * here, and the screens simply keep working the way they always did.
 */
export const REALTIME_KEY = (import.meta.env.VITE_REVERB_APP_KEY as string | undefined)?.trim() || ''
